import React from "react";

const LogoutIcon = (props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 36 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      >
      <path
        fill="none"
        d="M15 27.9473H11C10.4696 27.9473 9.96086 27.7366 9.58579 27.3615C9.21071 26.9864 9 26.4777 9 25.9473V11.9473C9 11.4168 9.21071 10.9081 9.58579 10.5331C9.96086 10.158 10.4696 9.94727 11 9.94727H15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fill="none"
        d="M22 23.9473L27 18.9473L22 13.9473"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fill="none"
        d="M27 18.9473H15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LogoutIcon;
